import React, { Component } from 'react';
import { Table, OverlayTrigger, Tooltip} from 'react-bootstrap';
import DBService from '../../service/DBService';
import { Link } from 'react-router-dom';

class ATSStockDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            atsList: [],
            limit: this.props.limit,
            symbol: this.props.symbol,
        };
    }

    componentDidMount() {
        DBService.getAtsStockWeeklyTotal(this.state.symbol, this.state.limit)
            .then(result => {
                console.log('getAtsStockWeeklyTotal', result);
                if (result !== undefined && result.data !== undefined && result.data.length > 0) {
                    this.setState({ atsList: result.data });
                }
            })
            .catch((error) => {
                console.log(error);
            });

    }

    renderRow(listValue) {
        if (listValue !== undefined && listValue.issueSymbolIdentifier !== undefined) {
            return (
                <tr key={Math.random()} >
                    <td style={{ textAlign: 'right' }}>{listValue.totalWeeklyShareQuantity}</td>
                    <td style={{ textAlign: 'right' }}>{listValue.totalWeeklyTradeCount}</td>
                    <td style={{ textAlign: 'right' }}>{listValue.lastUpdateDate}</td>
                </tr>
            )
        }
    }

    render() {
        let tableRow;
        if (this.state.atsList !== undefined && this.state.atsList.length !== undefined && this.state.atsList.length > 0) {
            tableRow = this.state.atsList.map(this.renderRow.bind(this));
        } else {
            tableRow = <tr><td></td><td>No Data</td><td></td></tr>
        }
        console.log('getAtsStockWeeklyTotal', this.state.atsList.length);

        return (
            <>
                <Link to={'/ats/' + this.state.symbol}>Alternative Trading System (Dark Pool)</Link> <Link style={{ fontSize: "10px"}} to={'/ats/' + this.state.symbol}>(More Details)</Link>
                <Table striped hover bordered size="xs" style={{ fontSize: "10px" }} responsive>
                    <thead>
                        <tr>
                            <th>Total Shares</th>
                            <th>Total Trades</th>
                            <th>Last Updated
                                &nbsp;&nbsp;
                                <OverlayTrigger
                                    placement="left"
                                    overlay={<Tooltip id="button-tooltip-2" style={{ wordBreak: 'break-all' }}>
                                        Alternative trading systems (ATS) are venues for matching large buy and sell transactions.<br /><br/>
                                        Institutional investors may use an ATS to find counterparties for transactions, instead of trading large blocks of shares on national stock exchanges. These actions may be designed to conceal trading from public view since ATS transactions do not appear on national exchange order books.<br/><br/>
                                        Alternative trading system (ATS) is the terminology used in the U.S. and Canada. In Europe, they are known as multilateral trading facilities.<br/>
                                    </Tooltip>}>
                                    <i style={{ color: '#8A2BE2', fontSize: '15px' }} className={"fa fa-question-circle"}></i>
                                </OverlayTrigger>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </Table>
            </>
        );
    }
}

export default ATSStockDetails;
